import { ModuleFilteredQuestions } from '@protos/learning_management/lms.assessment.teacher.apis_pb';

// ------------------------------------------------------------

export const createChapterList = (
  initialData: ModuleFilteredQuestions | undefined
) => {
  return (
    initialData?.taskMetaInfo?.chapterInfo?.chapterTopicsInfo.map((data) => {
      return {
        name: `${data.chapterNo}. ${data.name}`,
        id: data.chapterId,
        checked: true,
      };
    }) || []
  );
};

// ------------------------------------------------------------

export const createTopicList = ({
  initialData,
  chapterList,
}: {
  initialData: ModuleFilteredQuestions | undefined;
  chapterList: { name: string; id: number; checked: boolean }[];
}) => {
  if (!initialData) return [];

  // Get all checked chapter IDs from chapterList
  const selectedChapterIds = chapterList
    .filter((chapter) => chapter.checked)
    .map((chapter) => chapter.id);

  // Get topics from all selected chapters
  return (
    initialData?.taskMetaInfo?.chapterInfo?.chapterTopicsInfo
      ?.filter((chapter) => selectedChapterIds.includes(chapter.chapterId))
      ?.flatMap(
        (chapter) =>
          chapter.topicInfo?.map((topic) => ({
            name: topic.name,
            id: topic.topicId,
            checked: true,
          })) || []
      ) || []
  );
};

// ------------------------------------------------------------
